export default {
  empty: '暂无数据',
  loading: '数据加载中...',
  emptySearch: '暂无查询结果',
};
